import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";

function BtnChangLang() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === "ar" ? "en" : "ar";

    i18n.changeLanguage(newLang).then(() => {
      localStorage.setItem("lang", newLang);

      document
        .querySelectorAll(".modal-backdrop, .offcanvas-backdrop")
        .forEach((el) => el.remove());

      document.body.classList.remove(
        "modal-open",
        "offcanvas-backdrop",
        "show"
      );
    });
  };

  return (
    <button
      onClick={toggleLanguage}
      className="btn border-0 p-0 m-0 fw-bold shadow-sm"
      style={{ background: "none", color: "#00ACE7" }}
      aria-label="Toggle Language"
    >
      {currentLang === "ar" ? (
        <span className="ms-3">En</span>
      ) : (
        <span>عربي</span>
      )}
    </button>
  );
}

export default BtnChangLang;
